import {
  enumBillSortOption,
  enumBillStatus,
  enumFinancialAccountSortOption,
  enumInvoiceSortOption,
  enumInvoiceStatus,
} from '@rematter/frontend-lib-api-client';

import { billsQueryAtom } from '../_graphql/queryFinanceBills';
import { invoicesQueryAtom } from '../_graphql/queryFinanceInvoices';
import { financialAccountsQueryAtom } from '../_graphql/queryFinancialAccounts';

export const $overviewRecentBills = billsQueryAtom(() => ({
  variables: {
    limit: 5,
    sorting: [enumBillSortOption.CreatedAtDesc],
  },
}));

export const $overviewRecentInvoices = invoicesQueryAtom(() => ({
  variables: {
    limit: 5,
    sorting: [enumInvoiceSortOption.CreatedAtDesc],
  },
}));

export const $overviewFinancialAccounts = financialAccountsQueryAtom(() => ({
  variables: {
    limit: 10,
    sorting: [enumFinancialAccountSortOption.NameAsc],
  },
}));

export const $overviewPendingBills = billsQueryAtom(() => ({
  variables: {
    statuses: [enumBillStatus.Pending],
    limit: 100,
    sorting: [enumBillSortOption.DocumentDateAsc],
  },
}));

export const $overviewPendingInvoices = invoicesQueryAtom(() => ({
  variables: {
    statuses: [enumInvoiceStatus.Pending],
    limit: 100,
    sorting: [enumInvoiceSortOption.DocumentDateAsc],
  },
}));
